export const InstallAppButtonDataHooks = {
  button: 'install-app-button',
  tooltip: 'install-app-button-tooltip',
};
